<template ref="businessList">
  <section class="index-new-product-root">
    <h1 class="u-h1">
      <h2 class="cn animate__flipInY animate__animated animate__slow">
        我们的业务
      </h2>
      <h4 class="en animate__fadeInUp animate__animated animate__slow">
        OUR BUSINESS
      </h4>
    </h1>
    <div class="certify" ref="certify">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in businessList" :key="index">
            <article class="nav-li" :data-index="index" :style="navLiStyle(item.bg_color)">
              <div class="imgBox" :data-index="index">
                <img class="img" :data-index="index" :src="item.cover_image" alt="">
              </div>
              <h5 class="h5" :data-index="index">{{ item.name }}</h5>
            </article>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div ref="currentCidList" class="currentCidList animate__animated" :class="{'showBox':currentCidList.length > 0 && showBox == 0,'animate_h_zoomInDown2':currentCidList.length > 0 && showBox == 2}" @mouseleave="changeBox(2)">
      <div class="triangle" :style="{'border-bottom-color':currentCidList[currentCid]?currentCidList[currentCid].bg_color:'#57a3f3'}"></div>
      <div class="m-product" id="m-product" :style="{'background':currentCidList[currentCid]?currentCidList[currentCid].bg_color:'#57a3f3'}">
        <div class="m-swiper">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in currentCidList" :key="index">
                <div class="swiper-li">
                  <div class="imgBox">
                    <img class="img" :src="item.img" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="product-menu">
          <li class="li" v-for="(item,index) in currentCidList" :key="index" :class="{'current':index == currentCid}" @click="changeSwiper(index)">{{ item.name }}</li>
        </ul>
      </div>
    </div>
    <!--<div class="example" v-if="showDrop" ref="example">
      <span class="drop"></span>
    </div>-->
  </section>
</template>
<script>
let certifySwiper;
let certifySwiper2;
export default {
  name       : 'index-new-product',
  components : {},
  props      : {
    businessList : {
      type    : Array,
      default : [],
    },
    animateShow : {
      type    : Boolean,
      default : false,
    },
  },
  data(){
    return {
      currentId     :0, // 一级目录
      value10       :0,
      currentCid    :0, // 二级目录的active index
      showBox       : 1,
      oneInit:false,
      showDrop:false,
      dropLocation:{},
      mouseId:0,
    };
  },
  computed : {
    currentCidList(){
      return this.businessList[this.currentId]?this.businessList[this.currentId].list:[];
    },
  },
  watch:{
    businessList:{
      handler(){
        this.$nextTick(() => {
          this.loadSwiepr();
          this.certifyHover();
        })
      }
    },
    currentCidList:{
      handler(e){
        if(e && e.length > 0){
          this.$nextTick(()=>{
            this.loadCurrentCidSwiper();
          })
        }
      }
    },
    showBox:{
      handler(e){
        if(e == 0 && this.currentCidList && this.currentCidList.length > 0){
          this.$emit('scrollBox');
          this.$nextTick(() => {
            this.loadCurrentCidSwiper();
          })
        }
      }
    }
  },
  created(){
  },
  methods    : {
    loadSwiepr(){
      let _this = this;
      certifySwiper = new window.Swiper('.certify .swiper-container', {
        watchSlidesProgress : true,
        slidesPerView       : 'auto',
        centeredSlides      : true,
        loop                : true,
        loopedSlides        : 5,
        autoplay            : false,
        observerParents     :true,
        observer            :true,
        slideToClickedSlide : true, // 设置为true则点击slide会过渡到这个slide。
        navigation          : {
          nextEl : '.swiper-button-next',
          prevEl : '.swiper-button-prev',
        },
        on                  : {
          progress      : function(progress){
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * 96 + 'px';
              var scale = 1 - Math.abs(slideProgress) / 10;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 2) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition : function(transition){
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
          slideChange : function(){
            _this.currentId = this.realIndex;
            // _this.changeBox(0);
          },
          click:function(){
            _this.currentId = this.realIndex;
            _this.changeBox(0);
          }
        },
      });
    },
    loadCurrentCidSwiper(){
      let _this = this;
      certifySwiper2 = new window.Swiper('#m-product .swiper-container', {
        direction  : 'vertical',
        autoplay   : false,
        initialSlide:_this.currentCid,
        mousewheel : {
          eventsTarged : '#m-product',
          releaseOnEdges:true,
        },
        on         : {
          slideChange : function(){
            if(_this.currentCidList){
              let len = _this.currentCidList.length;
              // console.log(this.realIndex, len);
              if (len <= this.realIndex) {
                _this.currentCid = len - 1;
              } else {
                _this.currentCid = this.realIndex;
              }
            }
          },
        },
      });
    },
    changeBox(boolen){
      /*if(this.oneInit){
        if(boolen != 0){
          this.showDrop = false;
        }
        this.showBox = (boolen == 0) ? true : false
      } else{
        this.oneInit = true
      }*/
      if (boolen != 0) {
        this.showDrop = false;
      }
      // this.showBox = (boolen == 0) ? true : false
      this.showBox = boolen;
      if(boolen == 2){
        Object.assign(this.$refs.currentCidList.style,{
          'display':'block'
        })
        setTimeout(()=>{
          Object.assign(this.$refs.currentCidList.style, {
            'display' : 'none'
          })
        },500)
      } else{
        Object.assign(this.$refs.currentCidList.style, {
          'display' : 'block'
        })
      }
    },
    navLiStyle(styleArr){
      return {
        'background':'linear-gradient(' + styleArr + ')'
      }
    },
    changeSwiper(index){
      certifySwiper2.slideTo(index, 0, false);
      this.currentCid = index
    },
    certifyHover(){
      let _this = this;
      this.$refs.certify.getElementsByTagName('article').forEach((item,index)=>{
        item.addEventListener('mouseover', (e) => {
          // console.log(Object.values(e.target.attributes));
          // console.log(e.target.attributes[1].value, certifySwiper.realIndex);
          let changeIndex = e.target.attributes[1].value;
          var arr = [0,1,2,3,4];
          var len = arr.splice(arr.findIndex(item => item == certifySwiper.realIndex),3);
          if(len.length < 3){
            len.push(...arr.splice(0,(3 - len.length)))
          }
          let cont = len.findIndex(item => item == changeIndex);
          if(cont >= 1 && cont != _this.mouseId){
            _this.mouseId = cont;
            certifySwiper.slideNext();
            if (cont == 2) {
              setTimeout(() => {
                certifySwiper.slideNext();
              }, 300)
            }
          } else if(cont == -1){
            let arr2 = JSON.parse(JSON.stringify(arr));
            if(len[0] == 1){
              arr2 = [4,0]
            }
            let reverseCont = -1 * (arr2.findIndex(item => item == changeIndex) + 1);
            if (reverseCont != _this.mouseId) {
              _this.mouseId = reverseCont;
              certifySwiper.slidePrev();
              if (reverseCont == -2) {
                setTimeout(() => {
                  certifySwiper.slidePrev();
                }, 300)
              }
            }
          }
          // if(len.findIndex(item == changeIndex)){}
          // console.log(arr.findIndex(item => item == certifySwiper.realIndex),3);
          /*certifySwiper.slideTo(changeIndex, 0, false);
          this.currentId = changeIndex*/
            // certifySwiper.slideNext();
        })
      })
    }
  },
};
</script>
<style scoped lang="scss">
@import "swiper.min.css";
.index-new-product-root{
  margin-bottom: 86px;
  /deep/ .certify{
    position: relative;
    width: 1124px;
    //width: 1004px;
    margin: 0 auto;
    .swiper-slide{
      height: 418px;
      width: 334px;
      background: #fff;
      box-shadow: 0 4px 10px #ddd;
      img{
        display: block;
      }
      p{
        line-height: 98px;
        padding-top: 0;
        text-align: center;
        color: #636363;
        font-size: 1.1em;
        margin: 0;
      }
    }
    .swiper-pagination{
      width: 100%;
      bottom: 20px;
    }
    .swiper-pagination-bullets .swiper-pagination-bullet{
      margin: 0 5px;
      border: 3px solid #fff;
      background-color: #d5d5d5;
      width: 10px;
      height: 10px;
      opacity: 1;
    }
    .swiper-pagination-bullets .swiper-pagination-bullet-active{
      border: 3px solid #00aadc;
      background-color: #fff;
    }
    .swiper-button-prev{
      left: -30px;
      width: 45px;
      height: 45px;
      background: url(../../assets/wm_button_icon.png) no-repeat;
      background-position: 0 0;
      background-size: 100%;
    }
    .swiper-button-prev:hover{
      background-position: 0 -46px;
      background-size: 100%
    }
    .swiper-button-next{
      right: -30px;
      width: 45px;
      height: 45px;
      background: url(../../assets/wm_button_icon.png) no-repeat;
      background-position: 0 -93px;
      background-size: 100%;
    }
     .swiper-button-next:hover{
      background-position: 0 -139px;
      background-size: 100%
    }
  }
  .nav-li{
    height: 418px;
    width: 334px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    .imgBox{
      height: 218px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover{
        @extend %btn_base;
      }
    }
    .img{
      max-height: 100%;
      max-width: 100%;
    }
    .h5{
      color:#fff;
      font-size: 34px;
      font-weight: normal;
    }
  }
  .currentCidList{
    margin-top: 20px;
    display: none;
    &.showBox{
      display: block;
      animation-name: hZoomInDown;
    }
    .triangle{
      margin: auto;
      $border-lenght: 27px;
      border-bottom: $border-lenght solid red;
      border-left: $border-lenght solid transparent;
      border-right: $border-lenght solid transparent;
      width: $border-lenght;
    }
  }
  .m-product{
    $product-h:654px;
    overflow: hidden;
    position: relative;
    margin:0 20px 106px;
    height: $product-h;
    width: calc(100% - 40px);
    padding: 0 3%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    border-radius: 30px;
    .product-menu{
      flex-shrink: 0;
      margin: 98px 0;
      height: 100%;
      color:#fff;
      font-size: 20px;
      .li{
        border-right: 2px dotted #fff;
        padding: 30px 52px;
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        user-select: none;
        &.current:after{
          position: absolute;
          content: '';
          width: 20px;
          height: 20px;
          background: #fff;
          border-radius: 50%;
          top:calc(50% - 10px);
          right: -10px;
        }
      }
    }
    .m-swiper{
      flex:1;
      height: $product-h;
      .swiper-li{
        display: flex;
        align-items: center;
        .imgBox{
          flex-shrink: 0;
          margin-right: 3%;
          width: 100%;
          height: $product-h;
          display: flex;
          align-items: center;
          justify-content: center;
          .img{
            max-width: 100%;
          }
        }
      }
    }
  }
  .m-slider{
    transform: rotate(90deg);
  }
  @keyframes hZoomInDown{
    0%{opacity: 0;transform: translateY(-100%) scale3d(.3, .3, .3);}
    40%{opacity: 1;}
  }
  @keyframes hZoomInDown2{
    0%{opacity: 1;}
    40%{opacity: 0;transform: translateY(-100%) scale3d(.3, .3, .3);}
  }
  .animate_h_zoomInDown{animation-name: hZoomInDown;}
  .animate_h_zoomInDown2{animation-name: hZoomInDown2;}
}
</style>
